import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  deleteCursoInteres,
  getCursoIntereses,
} from "../../../../api/cursoInteres";
import { Button, Tooltip } from "@material-ui/core";
import { buttonsStyle } from "../../../components/tables/table";
import { Delete } from "@material-ui/icons";
import { alertError, alertSuccess } from "../../../../utils/logger";

function getText(obj, fallback = "") {
  if (!obj) return fallback;
  if (typeof obj === "string") return obj;
  return obj.es || obj.ca || obj.en || fallback;
}

export default function CursoInteresesPage() {
  const [items, setItems] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedIdToDelete, setSelectedIdToDelete] = useState(null);
  const [mensajeModal, setMensajeModal] = useState({
    open: false,
    text: "",
    anchorLeft: 0,
    anchorTop: 0,
  });

  useEffect(() => {
    getCursoIntereses()
      .then((res) => {
        if (res.status === 200) {
          setItems(res.data || []);
          setRefresh(false);
        }
      })
      .catch(() => {});
  }, [refresh]);

  const filtered = useMemo(() => {
    const s = (searchText || "").toLowerCase().trim();
    if (!s) return items;
    return (items || []).filter((x) => {
      const titulo = getText(x?.curso?.titulo, "").toLowerCase();
      const email = (x?.email || "").toLowerCase();
      const nombre = (x?.nombre || "").toLowerCase();
      const mensaje = (x?.mensaje || "").toLowerCase();
      return (
        titulo.includes(s) ||
        email.includes(s) ||
        nombre.includes(s) ||
        mensaje.includes(s)
      );
    });
  }, [items, searchText]);

  const columns = [
    {
      dataField: "cursoTitulo",
      text: "Formación",
      sort: true,
    },
    { dataField: "email", text: "Correo", sort: true },
    { dataField: "nombre", text: "Nombre", sort: true },
    {
      dataField: "mensaje",
      text: "Mensaje",
      sort: false,
      formatter: (cell) => {
        if (!cell) return "-";
        const s = String(cell);
        const truncated = s.slice(0, 80) + (s.length > 80 ? "…" : "");
        const isLong = s.length > 80;
        return (
          <span
            style={{
              cursor: isLong ? "pointer" : "default",
              borderBottom: isLong ? "1px dotted rgba(0,0,0,0.35)" : "none",
            }}
            onClick={(e) => {
              if (!isLong) return;
              const rect = e.currentTarget.getBoundingClientRect();
              const panelWidth = 520;
              const panelMaxHeight = 420;
              const left = Math.max(
                8,
                Math.min(rect.left, window.innerWidth - panelWidth - 8),
              );
              const preferredTop = rect.bottom + 8;
              const topFitsBelow =
                preferredTop + panelMaxHeight <= window.innerHeight - 8;
              const top = topFitsBelow
                ? preferredTop
                : Math.max(8, rect.top - 8 - panelMaxHeight);
              setMensajeModal({
                open: true,
                text: s,
                anchorLeft: left,
                anchorTop: top,
              });
            }}
          >
            {truncated}
          </span>
        );
      },
    },
    { dataField: "createdAt", text: "Fecha", sort: true },
    {
      dataField: "_id",
      text: "Acciones",
      formatter: (cell) => {
        return (
          <Tooltip title="Eliminar">
            <Button
              size="small"
              style={buttonsStyle}
              onClick={() => {
                setSelectedIdToDelete(cell);
                setOpenConfirmDialog(true);
              }}
            >
              <Delete style={{ color: "#dc3545" }} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  const data = (filtered || []).map((x) => ({
    _id: x._id,
    cursoTitulo: getText(x?.curso?.titulo, "") || x?.curso?.code || "",
    email: x.email || "",
    nombre: x.nombre || "",
    mensaje: x.mensaje || "",
    createdAt: x.createdAt ? new Date(x.createdAt).toLocaleString("es-ES") : "",
  }));

  return (
    <Card>
      <CardHeader title="Interesados" />
      <CardBody>
        <div className="row" style={{ marginBottom: 15 }}>
          <div className="col-md-4 col-sm-6 mb-2">
            <TextField
              label="Buscar"
              placeholder="Curso, correo, nombre, mensaje…"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value || "")}
              margin="dense"
              variant="outlined"
              fullWidth
            />
          </div>
        </div>

        <Dialog
          open={mensajeModal.open}
          disableScrollLock
          hideBackdrop
          onClose={() => setMensajeModal((prev) => ({ ...prev, open: false }))}
          PaperProps={{
            style: {
              position: "fixed",
              left: mensajeModal.anchorLeft,
              top: mensajeModal.anchorTop,
              margin: 0,
              maxWidth: 520,
              maxHeight: "min(55vh, 420px)",
              overflow: "auto",
              pointerEvents: "auto",
            },
          }}
        >
          <DialogTitle style={{ paddingBottom: 8 }}>
            Mensaje completo
          </DialogTitle>
          <DialogContent style={{ paddingTop: 0 }}>
            <Typography
              component="div"
              variant="body2"
              style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              {mensajeModal.text}
            </Typography>
          </DialogContent>
        </Dialog>

        <ConfirmDialog
          title={"¿Seguro que quieres borrar este interés?"}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            if (!selectedIdToDelete) return;
            deleteCursoInteres(selectedIdToDelete)
              .then((res) => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({ customMessage: "Interés borrado." });
                  setRefresh(true);
                }
              })
              .catch((err) => {
                alertError({
                  error: err,
                  customMessage: "No se pudo borrar el interés.",
                });
              });
          }}
        />

        <Table
          data={data}
          columns={columns}
          pageKey="cursoInteresesPage"
          searchText={searchText}
          onSearchChange={setSearchText}
        />
      </CardBody>
    </Card>
  );
}
